import * as Yup from "yup";

export const loginSchema = Yup.object({
  Username: Yup.string().trim().required("Username is required"),
  Password: Yup.string().trim().required("Password is required"),
});

export const verifyCodeSchema = Yup.object({
  code: Yup.string().trim().required("code is required"),
});
